import type { FetchProgressController } from '@frontend/controllers';

//fetchAndTrack(): Helper to fetch and track progress
//* wraps what-wg fetch with ability to use fetchProgress
export const fetchAndTrack = async (
  url: string,
  {
    fetchProgress,
    ...fetchOptions
  }: RequestInit & { fetchProgress?: FetchProgressController },
): Promise<Response> => {
  try {
    fetchProgress?.startRequest();
    const response = await fetch(url, fetchOptions);
    return fetchProgress ? fetchProgress.startResponse(response) : response;
  } catch (err) {
    fetchProgress?.requestError(err);
    throw err;
  }
};
